export default __webpack_public_path__ + "static/image10-24a3a732999f9dc7ca061292b68b3929.jpg";